import React from 'react';
import SiteOperationProgress from '../SiteControl/SiteOperationProgress';
import ScreenOperationProgress from '../SiteControl/ScreenOperationProgress';

export default function RemotePowerDiagnostics({ siteName, screenName, siteExecution, screenExecution }) {
  return <section className="phone-remote__screen-routines" aria-label="Power diagnostics">
    <strong>Power diagnostics</strong>
    <p>{siteName || 'Selected site'}{screenName ? ` · ${screenName}` : ''}</p>
    <SiteOperationProgress {...siteExecution} />
    <ScreenOperationProgress {...screenExecution} />
    {!siteExecution.operation && !siteExecution.error && !screenExecution.operation && !screenExecution.error && (
      <p>No routine results yet. Run Site Startup, Site Shutdown, Start Screen or Stop Screen from the Remote power controls, then review the diagnostics here.</p>
    )}
  </section>;
}
